export const redirectWithToken = (destination: string, accessToken: string) => {
    try {
        const redirectUrl = new URL(destination);
        redirectUrl.searchParams.set('access_token', accessToken);
        window.location.href = redirectUrl.toString();
    } catch {
        window.location.href = destination;
    }
};